import { Hub } from "aws-amplify/utils";
import { useEffect, useRef, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { resolvePostLoginPath } from "../login/postLoginRedirect";
import { AuthenticationInProgressPage } from "./AuthenticationInProgressPage";

// landing page is just a redirector to the login / home route, depending on the auth state
// (the "code" parameter is used for detecting redirect from the federated sign in - it takes some
// time to exchange the code to the tokens, so display a interstitial page after redirect)
type AuthState = "InProgress" | "LoggedIn" | "LoggedOut" | "LoginFailed";

export const LandingPage = () => {
  const [searchParams] = useSearchParams();
  const [authState, setAuthState] = useState<AuthState>(() =>
    searchParams.get("code") ? "InProgress" : "LoggedIn",
  );
  const postLoginPathRef = useRef<string | undefined>(undefined);

  if (authState === "LoggedIn" && postLoginPathRef.current === undefined) {
    postLoginPathRef.current = resolvePostLoginPath();
  }

  useEffect(() => {
    return Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signedIn":
          setAuthState("LoggedIn");
          break;
        case "signedOut":
          setAuthState("LoggedOut");
          break;
        case "signInWithRedirect_failure":
          setAuthState("LoginFailed");
          // TODO: show sign in failure reason (Toast)?
          console.error("SignIn failed");
          break;
        case "tokenRefresh_failure":
      }
    });
  }, []);

  // useAuth hook triggers the token exchange calls (pool + federated sign in)
  useAuth();

  return {
    InProgress: <AuthenticationInProgressPage />,
    LoggedIn: <Navigate to={postLoginPathRef.current ?? "/home"} replace />,
    LoggedOut: <Navigate to="/login" />,
    LoginFailed: <Navigate to="/login" />,
  }[authState];
};
